module.exports = __webpack_public_path__ + "img/file-earmark-bar-graph.c8332a9e.svg";